import {Nullable, ReferralsManagementListing} from 'common/types';
import {
  FETCH_REFERRALS_MANAGEMENT_LISTING_FAILURE,
  FETCH_REFERRALS_MANAGEMENT_LISTING_REQUEST,
  FETCH_REFERRALS_MANAGEMENT_LISTING_SUCCESS,
  ReferralsAction,
} from '../types';

interface State {
  data: Nullable<ReferralsManagementListing>;
  isFetching: boolean;
  error: Nullable<Error>;
}

const initialState: State = {
  data: null,
  isFetching: false,
  error: null,
};

export const managementReducer = (
  state: State = initialState,
  action: ReferralsAction
) => {
  switch (action.type) {
    case FETCH_REFERRALS_MANAGEMENT_LISTING_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case FETCH_REFERRALS_MANAGEMENT_LISTING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case FETCH_REFERRALS_MANAGEMENT_LISTING_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
